import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { Users } from "lucide-react";
import {CompanyAccount, ActiveAccount, CancelledAccount, NewAccounts } from "./CompanyAccount";


const AccountOverview = ({ dateFilter }) => {
  const getDateDescription = () => {
    return dateFilter === "today"
      ? "Today's"
      : dateFilter === "yesterday"
      ? "Yesterday's"
      : `Last ${
          dateFilter === "7days"
            ? "7"
            : dateFilter === "30days"
            ? "30"
            : "90"
        } days`;
  };

  return (
    <Card className="bg-[#2c3440] dark:bg-[#1A1F2C] text-white border-none shadow-lg hover:shadow-xl transition-all p-24 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="pb-8">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-bold text-white flex items-center">
            <Users className="h-5 w-5 mr-8 text-[#9b87f5]" />
            Account Overview
          </CardTitle>
          <Button variant="link" asChild>
            <a href={"/accounts"} style={{ color: "#1EAEDB" }}>
              View All
            </a>
          </Button>
        </div>
        <CardDescription className="text-gray-400 text-center">
          {`${getDateDescription()} account metrics`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <CompanyAccount dateFilter={dateFilter} />
          <ActiveAccount dateFilter={dateFilter} />
          <NewAccounts dateFilter={dateFilter} />
          <CancelledAccount dateFilter={dateFilter} />
        </div>
      </CardContent>
    </Card>
  );
};

export default AccountOverview;
